// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2pMA4","text":"SelectPayment_text__20nxN","title":"SelectPayment_title__2lT-W","btn":"SelectPayment_btn__28lrW"};